import { render, staticRenderFns } from "./UtilBadgeCount.vue?vue&type=template&id=0b49084c&scoped=true"
import script from "./UtilBadgeCount.vue?vue&type=script&lang=js"
export * from "./UtilBadgeCount.vue?vue&type=script&lang=js"
import style0 from "./UtilBadgeCount.vue?vue&type=style&index=0&id=0b49084c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49084c",
  null
  
)

export default component.exports